<template>
  <el-card>
    <template #header>
      <div class="header-class">
        <div>
          <content-header />
        </div>
        <div class="wid-class">
          <span>有效用户:</span><span class="font-col">{{ user_true_total }}</span>
          <span>总用户:</span><span class="font-col">{{ user_total }}</span>
        </div>
      </div>
    </template>

    <search-form
      ref="searchForm"
      :fields="search"
    />

    <el-table
      :data="users"
      style="font-size:12px;"
      resource="user"
    >

      <el-table-column
        prop="mobile"
        label="手机号码"
        align="center"
        min-width="120"
        show-overflow-tooltip
      />
      <el-table-column
        prop="deposit_status"
        align="center"
        label="押金状态"
        min-width="120"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-popover
            trigger="hover"
            :disabled="scope.row.deposit_type !== 2"
            placement="top"
          >
            <p>免押金卡到期时间: {{ scope.row.deposit_expire_time }}</p>
            <div
              slot="reference"
              class="name-wrapper"
            >
              <el-tag
                v-if="scope.row.is_deposit == 1 && scope.row.deposit_type == 1"
                type="success"
              >{{
                scope.row.deposit_status }}
              </el-tag>
              <el-tag
                v-else-if="scope.row.is_deposit == 1 && scope.row.is_student == 0 && scope.row.deposit_type == 2"
                type="warning"
              >{{ scope.row.deposit_status }}
              </el-tag>
              <el-tag
                v-else-if="scope.row.is_deposit == 1 && scope.row.is_student > 0 && scope.row.deposit_type == 2"
                type="primary"
              >{{ scope.row.deposit_status }}
              </el-tag>
              <el-tag
                v-else
                type="danger"
              >{{ scope.row.deposit_status }}</el-tag>
            </div>
          </el-popover>
        </template>
        <!-- <template slot-scope="scope">
          <el-tag v-if="scope.row.is_deposit == 1" type="success">{{ scope.row.deposit_status }}</el-tag>
          <el-tag v-else type="danger">{{ scope.row.deposit_status }}</el-tag>
        </template> -->
      </el-table-column>
      <el-table-column
        prop="card_status"
        label="实名状态"
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.is_card_certified == 1"
            type="success"
          >{{ scope.row.card_status }}</el-tag>
          <el-tag
            v-else
            type="danger"
          >{{ scope.row.card_status }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="truename"
        align="center"
        label="真实姓名"
        min-width="120"
        show-overflow-tooltip
      />
      <el-table-column
        prop="register_source"
        align="center"
        label="用户来源"
        min-width="120"
        show-overflow-tooltip
      />
      <!--  <el-table-column
        prop="card_id"
        align="center"
        label="身份证号码"
        show-overflow-tooltip
        min-width="8%"
      />-->
      <el-table-column
        prop="wallet_money"
        align="center"
        label="账户余额"
        min-width="120"
      />
      <!-- <el-table-column prop="card_id" label="身份证号码">
        <template #default="{ row }">
          <input-edit
            :id="row.id"
            field="card_id"
            :update="updateUser"
            v-model="row.card_id"
          />
        </template>
      </el-table-column> -->

      <!-- <el-table-column prop="register_source" label="注册来源" min-width="5%"/> -->
      <el-table-column
        prop="areas.name"
        label="所属区域"
        show-overflow-tooltip
        align="center"
        min-width="120"
      />
      <!--<el-table-column
        prop="created_at"
        align="center"
        show-overflow-tooltip
        min-width="8%"
        label="注册时间"
      />-->
      <el-table-column
        label="使用状态"
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.status==1"
            type="success"
            size="mini"
            plain
          >
            {{ scope.row.account_status }}
          </el-button>
          <el-button
            v-if="scope.row.status==0"
            type="danger"
            size="mini"
            plain
          >
            {{ scope.row.account_status }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        min-width="120"
      >
        <template #default="{  row }">
          <input-edit
            :id="row.id"
            field="remark"
            :update="updateUser"
            v-model="row.remark"
          />
        </template>
      </el-table-column>

      <el-table-column
        label="操作1"
        align="center"
        fixed="right"
        width="400"
      >
        <template slot-scope="scope">
          <el-button
            @click="settingClick(scope.row)"
            type="primary"
            size="mini"
          >设置</el-button>
          <el-button
            @click="phoneClick(scope.row)"
            type="info"
            size="mini"
          >机型</el-button>
          <el-button
            v-if="scope.row.is_bind_mobile == 1"
            @click="activeClick(scope.row)"
            type="warning"
            size="mini"
          >
            活动
          </el-button>
          <el-button
            v-if="scope.row.is_deposit == 1 && scope.row.deposit_type == 1"
            @click="returnDepositDialog(scope.row)"
            type="danger"
            size="mini"
          >
            退还押金
          </el-button>
<!--          <el-button-->
<!--            v-show="returnBalanceShow && scope.row.wallet_money != 0"-->
<!--            @click="returnBalance(scope.row)"-->
<!--            type="success"-->
<!--            size="mini"-->
<!--          >-->
<!--            退还余额-->
<!--          </el-button>-->
        </template>
      </el-table-column>
    </el-table>
    <div class="card-footer">
      <pagination :page="page" />
    </div>
    <el-dialog
      title="用户设置"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <div>
        <span class="label-name">账号状态:</span>
        <el-radio
          v-model="status"
          label="0"
        >暂停使用</el-radio>
        <el-radio
          v-model="status"
          label="1"
        >正常</el-radio>
      </div>
      <div>
        <span class="label-name">真实姓名:</span>
        <el-input
          size="small"
          style="width:50%;"
          v-model="realName"
          placeholder="请输入内容"
        />
      </div>
      <div>
        <span class="label-name">身份证号:</span>
        <el-input
          size="small"
          style="width:50%;"
          v-model="idCard"
          placeholder="请输入内容"
        />
      </div>
      <div>
        <span class="label-name">实名状态:</span>
        <el-radio
          v-model="realNameStatus"
          label="0"
        >未实名</el-radio>
        <el-radio
          v-model="realNameStatus"
          label="1"
        >已实名</el-radio>
      </div>
      <div>
        <span class="label-name">骑行年龄状态:</span>
        <el-radio
          v-model="rideAgeStatus"
          label="0"
        >未通过</el-radio>
        <el-radio
          v-model="rideAgeStatus"
          label="1"
        >已通过</el-radio>
      </div>
      <div>
        <span class="label-name">手机号:</span>
        <el-input
          size="small"
          style="width:50%;"
          v-model="mobile"
          placeholder="请输入内容"
        />
      </div>
      <div>
        <span class="label-name">手机号状态:</span>
        <el-radio
          v-model="mobileBindStatus"
          label="0"
        >未绑定</el-radio>
        <el-radio
          v-model="mobileBindStatus"
          label="1"
        >已绑定</el-radio>
      </div>
      <!-- <div v-show="status=='0'">
        <span class="label-name">暂停原因:</span> <el-input class="textarea-class" type="textarea" v-model="reason"/>
      </div> -->
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="SubmitSetting"
        >确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="退还押金"
      :visible.sync="return_deposit_dialogVisible"
      width="30%"
    >
      <p>确定退还押金嘛</p>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="return_deposit_dialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="returnDeposit"
        >确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="用户机型详情"
      :visible.sync="phonedialogVisible"
      width="30%"
    >
      <div class="info-wrpp">
        <div class="table-class">
          <el-table
            :data="tableData3"
            style="width: 100%"
          >
            <el-table-column
              prop="label"
              label="类型"
              align="center"
              width="150"
              show-overflow-tooltip
            />
            <el-table-column
              prop="value"
              label="数据值"
              align="center"
              show-overflow-tooltip
            />
          </el-table>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="退还余额"
      :visible.sync="BalanceShow"
      width="30%"
    >
      <div>
        <el-form
          ref="returnBalanceForm"
          :model="returnBalanceForm"
          label-width="150px"
        >
          <el-form-item label="用户名（真名）">
            <span>{{ nickname }}({{ realName }})</span>
          </el-form-item>
          <el-form-item label="头像">
            <img
              :src="avatar"
              min-width="30"
              height="30"
            >
          </el-form-item>
          <el-form-item label="现有余额">
            <span>{{ returnBalanceForm.balance_now }}</span>
          </el-form-item>
          <el-form-item label="总充值到账">
            <span>{{ returnBalanceForm.total_recharge }}</span>
          </el-form-item>
          <el-form-item label="后台订单返还到账">
            <span>{{ returnBalanceForm.order_refund_money }}</span>
          </el-form-item>
          <el-form-item label="总充值实际支付">
            <span>{{ returnBalanceForm.total_pay_recharge }}</span>
          </el-form-item>
          <el-form-item label="已消费">
            <span> {{ returnBalanceForm.consumed }}</span>
          </el-form-item>
          <el-form-item label="用户实际到账">
            <span style="color:red;"> {{ returnBalanceForm.money }}</span>
          </el-form-item>
          <el-form-item label="余额实际扣款">
            <span style="color:red;"> {{ returnBalanceForm.subBalance }}</span>
          </el-form-item>
          <el-form-item>
            <el-button @click="BalanceShow = false">取 消</el-button>
            <el-button
              type="primary"
              @click="balanceRefund(returnBalanceForm)"
            >确定退还</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog
      title="活动"
      :visible.sync="dialogVisibleActive"
      width="30%"
    >
      <!-- <span>这是一段信息</span>
      -->
      <el-tabs type="card">
        <el-tab-pane label="优惠券活动">
          <div>
            <el-form
              ref="formq"
              :model="formq"
              :rules="ruleq"
              label-width="150px"
            >
              <el-form-item
                prop="coupon_id"
                required
                label="优惠券"
              >
                <el-select
                  class="limit-width"
                  v-model="formq.coupon_id"
                  placeholder="请选择"
                >
                  <el-option
                      v-for="item in coupons"
                      :key="item.id"
                      :label="item.title"
                      :value="item.id"
                  />
                </el-select>
              </el-form-item>
                <!-- <el-form-item label="用户手机号" required prop="mobile">
                  <el-input @keyup.enter.native="searchUser" v-model="form.mobile"/>
                </el-form-item> -->
                <el-form-item label="手机号">
                    <span>{{ mobile }}</span>
                </el-form-item>
                <!--              <el-form-item label="用户名（真名）">-->
                <!--                <span>{{ nickname }}({{ realName }})</span>-->
                <!--              </el-form-item>-->
                <!--              <el-form-item label="头像">-->
                <!--                <img-->
                <!--                  :src="avatar"-->
                <!--                  min-width="30"-->
                <!--                  height="30"-->
                <!--                >-->
                <!--              </el-form-item>-->
                <el-form-item>
                    <el-button @click="dialogVisibleActive = false">取 消</el-button>
                    <el-button
                        type="primary"
                        @click="songquan"
                    >确 定
                    </el-button>
                </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane label="骑行卡活动">
          <div>
            <el-form
              ref="formk"
              :model="formk"
              :rules="rulek"
              label-width="150px"
            >
              <el-form-item
                prop="card_id"
                required
                label="骑行卡"
              >
                <el-select
                    class="limit-width"
                    v-model="formk.card_id"
                    placeholder="请选择"
                >
                    <el-option
                        v-for="item in cards"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    />
                </el-select>
              </el-form-item>
                <el-form-item label="手机号">
                    <span>{{ mobile }}</span>
                </el-form-item>
                <!--              <el-form-item label="用户名（真名）">-->
                <!--                <span>{{ nickname }}({{ realName }})</span>-->
                <!--              </el-form-item>-->
                <!--              <el-form-item label="头像">-->
                <!--                <img-->
                <!--                  :src="avatar"-->
                <!--                  min-width="30"-->
                <!--                  height="30"-->
                <!--                >-->
                <!--              </el-form-item>-->
                <el-form-item>
                    <el-button @click="dialogVisibleActive = false">取 消</el-button>
                    <el-button
                        type="primary"
                        @click="songka"
                    >确 定
                    </el-button>
                </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane label="免押金卡活动">
          <div>
            <el-form
              ref="formdk"
              :model="formdk"
              :rules="ruledk"
              label-width="150px"
            >
              <el-form-item
                prop="card_id"
                required
                label="免押金卡"
              >
                <el-select
                    class="limit-width"
                    v-model="formdk.card_id"
                    placeholder="请选择"
                >
                    <el-option
                        v-for="item in dCards"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    />
                </el-select>
              </el-form-item>
                <el-form-item label="手机号">
                    <span>{{ mobile }}</span>
                </el-form-item>
                <!--              <el-form-item label="用户名（真名）">-->
                <!--                <span>{{ nickname }}({{ realName }})</span>-->
                <!--              </el-form-item>-->
                <!--              <el-form-item label="头像">-->
                <!--                <img-->
                <!--                  :src="avatar"-->
                <!--                  min-width="30"-->
                <!--                  height="30"-->
                <!--                >-->
                <!--              </el-form-item>-->
                <el-form-item>
                    <el-button @click="dialogVisibleActive = false">取 消</el-button>
                    <el-button
                        type="primary"
                        @click="songDepositCard"
                    >确 定
                    </el-button>
                </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane
          :disabled="balanceShow"
          label="充值余额"
        >
          <div>
            <el-form
              ref="balanceForm"
              :model="balanceForm"
              :rules="balanceRule"
              label-width="150px"
            >
              <el-form-item
                prop="money"
                required
                label="充值金额"
              >
                <el-input-number
                    v-model="balanceForm.money"
                    :precision="2"
                    :step="0.1"
                    :max="1000"
                    :min="0"
                />
              </el-form-item>
                <el-form-item
                    prop="remark"
                    required
                    label="备注"
                >
                    <el-input v-model="balanceForm.remark"/>
                </el-form-item>
                <!--              <el-form-item label="用户名（真名）">-->
                <!--                <span>{{ nickname }}({{ realName }})</span>-->
                <!--              </el-form-item>-->
                <el-form-item label="手机号">
                    <span>{{ mobile }}</span>
                </el-form-item>
                <!--              <el-form-item label="头像">-->
                <!--                <img-->
                <!--                  :src="avatar"-->
                <!--                  min-width="30"-->
                <!--                  height="30"-->
                <!--                >-->
                <!--              </el-form-item>-->
                <el-form-item>
                    <el-button @click="dialogVisibleActive = false">取 消</el-button>
                    <el-button
                        type="primary"
                        :loading="rechargeBalanceButton"
                        @click="rechargeBalance()"
                    >确 定
                    </el-button>
                </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </el-card>

</template>

<script>
import SearchForm from "@c/SearchForm";
import Pagination from "@c/Pagination";
import {
  getUsers,
  updateUsersStatus,
  getUserNumber,
  updateUser,
  userReturnDeposit,
  rechargeBalanceToUser,
  refundBalanceToUser
} from "@/api/users";
import { getAreas } from "@/api/area";
import InputEdit from "@c/quick-edit/InputEdit";
import { mixinsAutoPageSize, isAdministrator, can } from "@/libs/utils";
import { giveCardToUser, getRidingCard } from "@/api/card-riding";
import { getCoupon, giveCouponToUser } from "@/api/coupon";
import { getDepositCard, giveDepositCardToUser } from "@/api/deposit-cards";
import { getAdminUsersMerchant } from "@/api/admin-merchant";
import env from "../../env";
export default {
  name: "Index",
  components: {
    SearchForm,
    Pagination,
    InputEdit
  },
  data() {
    return {
      isPosSwitch: env.isPosSwitch, //是否允许开启商户切换
      search: [
        {
          type: "super-input",
          field: "mobile_nickname",
          label: "用户手机号"
        },
        {
          field: "truename",
          label: "真实姓名"
        },
        {
          type: "el-select",
          field: "register_area_id",
          label: "骑行区域",
          options: [
            {
              id: "",
              name: "全部"
            }
          ]
        },
        {
          type: "el-select",
          field: "is_card_certified",
          label: "实名认证状态",
          options: [
            {
              id: "",
              name: "全部"
            },
            {
              value: "0",
              label: "未实名"
            },
            {
              value: "1",
              label: "已实名"
            }
          ]
        },
        {
          type: "el-select",
          field: "deposit_type",
          label: "押金缴纳类型",
          options: [
            {
              id: "",
              name: "全部"
            },
            {
              value: "0",
              label: "未缴纳"
            },
            {
              value: "1",
              label: "缴纳押金"
            },
            {
              value: "2",
              label: "免押金卡"
            }
          ]
        },
        {
          type: "el-select",
          field: "is_bind_mobile",
          label: "是否绑定手机号",
          options: [
            {
              id: "",
              name: "全部"
            },
            {
              value: "0",
              label: "未绑定"
            },
            {
              value: "1",
              label: "已绑定"
            }
          ]
        },
        {
          type: "el-select",
          field: "status",
          label: "使用状态",
          options: [
            {
              id: "",
              name: "全部"
            },
            {
              value: "0",
              label: "暂停使用"
            },
            {
              value: "1",
              label: "正常"
            }
          ]
        },
        {
          field: "remark",
          label: "备注"
        }
      ],
      users: [],
      page: null,
      user_total: "",
      user_true_total: "",
      dialogVisible: false,
      nickname: "",
      status: "",
      realName: "",
      register_source: "",
      idCard: "",
      realNameStatus: "",
      rideAgeStatus: "",
      mobile: "",
      mobileBindStatus: "",
      reason: "",
      row_id: "",
      return_deposit_user_id: "",
      return_deposit_dialogVisible: false,
      phonedialogVisible: false,
      tableData3: [],
      first_blood: true,
      dialogVisibleActive: false,
      returnBalanceShow: false,
      BalanceShow: false,
      returnBalanceFormId: "",
      returnBalanceForm: {},
      avatar: "",
      cards: [],
      coupons: [],
      dCards: [],
      formq: {
        coupon_id: "",
        mobile: "",
        id: 0
      },
      ruleq: {
        coupon_id: [
          { required: true, message: "请选择赠送得优惠券", trigger: "change" }
        ]
      },
      formk: {
        card_id: "",
        mobile: "",
        id: 0
      },
      rulek: {
        card_id: [
          { required: true, message: "请选择赠送得骑行卡", trigger: "change" }
        ]
      },
      formdk: {
        card_id: "",
        mobile: "",
        id: 0
      },
      ruledk: {
        card_id: [
          { required: true, message: "请选择赠送得免押金卡", trigger: "change" }
        ]
      },
      rechargeBalanceButton: false,
      balanceForm: {
        money: "",
        remark: "",
        mobile: "",
        id: 0
      },
      balanceRule: {
        money: [{ required: true, message: "请输入金额", trigger: "change" }],
        remark: [{ required: true, message: "请输入备注", trigger: "change" }]
      },
      balanceShow: true
    };
  },
  inject: ["reload"],
  mixins: [mixinsAutoPageSize],

  watch: {
    $route: {
      async handler(newVal) {
        await this.autoPageSize(57, newVal);

        const {
          data: { data, meta }
        } = await getUsers(newVal.query);
        this.users = data;
        this.page = meta;
      },
      immediate: true
    }
  },
  async created() {
    this.balanceShow = !can("rechargeBalance");
    this.returnBalanceShow = can("returnBalance");
    console.log(this.returnBalanceShow);
    const [{ data: areas }, { data: userNumber }] = await Promise.all([
      getAreas({ all: 1 }),
      getUserNumber()
    ]);
    this.user_total = userNumber.user_total;
    this.user_true_total = userNumber.user_true_total;

    this.search[2].options.push.apply(this.search[2].options, areas);

    const { data: coupons } = await getCoupon({ all: 1 });
    this.coupons = coupons;

    const { data: depositCards } = await getDepositCard({ all: 1 });
    this.dCards = depositCards;

    const [{ data: cards }] = await Promise.all([
      getRidingCard({ all: 1, is_give: 1 })
    ]);
    this.cards = cards;

    if (this.$store.state.users.user.roles[0] === "administrator") {
      const [{ data: merchant }] = await Promise.all([
        getAdminUsersMerchant({ all: 1 })
      ]);
      if (env.isPosSwitch == true) {
        this.search.push({
          type: "el-select",
          field: "merchant_id",
          label: "商户",
          options: [
            {
              id: "",
              name: "全部"
            }
          ]
        });
        this.search[8].options.push.apply(
          this.search[8].options,
          merchant.data
        );
      }
    }

    // console.log(can('rechargeBalance'))
    // this.balanceShow = !isAdministrator()
  },
  methods: {
    updateUser,
    returnDepositDialog(row) {
      // 退还押金
      this.return_deposit_dialogVisible = true;
      this.return_deposit_user_id = row.id;
    },
    async returnDeposit() {
      const [{ data: res }] = await Promise.all([
        userReturnDeposit({ user_id: this.return_deposit_user_id })
      ]);

      if (res) {
        let msg = JSON.stringify(res);
        this.$message({
          type: "success",
          message: msg
        });
        this.reload();
      }
    },
    settingClick(row) {
      // 设置
      this.dialogVisible = true;
      this.nickname = row.nickname;
      this.status = row.status.toString();
      // console.log(row)
      this.realNameStatus = row.is_card_certified.toString();
      this.rideAgeStatus = row.is_match_ride_age.toString();
      this.mobileBindStatus = row.is_bind_mobile.toString();
      this.idCard = row.card_id;
      this.realName = row.truename;
      this.register_source = row.register_source;
      this.mobile = row.mobile;
      this.row_id = row.id;
      // console.log(row)
    },
    phoneClick(row) {
      if (row.phone_detail == "") {
        this.tableData3 = [];
      } else {
        this.tableData3 = JSON.parse(row.phone_detail);
      }
      this.phonedialogVisible = true;
    },
    activeClick(row) {
      this.nickname = row.nickname;
      this.realName = row.truename;
        this.mobile = row.mobile;
        this.formq.mobile = row.mobile;
      this.formq.id = row.id;
      this.formk.mobile = row.mobile;
      this.formk.id = row.id;
      this.formdk.mobile = row.mobile;
      this.formdk.id = row.id;
      this.balanceForm.mobile = row.mobile;
      this.balanceForm.id = row.id;
      this.avatar = row.avatar;
      this.dialogVisibleActive = true;
    },
    async SubmitSetting() {
      const [{ data: res }] = await Promise.all([
        updateUsersStatus({
          user_id: this.row_id,
          status: this.status,
          is_bind_mobile: this.mobileBindStatus,
          is_card_certified: this.realNameStatus,
          is_match_ride_age: this.rideAgeStatus,
          card_id: this.idCard,
          truename: this.realName,
          mobile: this.mobile
        })
      ]);

      if (res) {
        this.$message({
          type: "success",
          message: "修改成功!"
        });
        this.reload();
      }
    },

    songquan() {
      this.$refs["formq"].validate(valid => {
        if (valid) {
          giveCouponToUser(this.formq).then(res => {
            res.then(data => {
              if (data) {
                this.$message({
                  message: "操作成功",
                  type: "success"
                });
                this.dialogVisibleActive = false;
                this.formq.coupon_id = "";
                this.formq.mobile = "";
              }
            });
          });
        } else {
          alert("请检查输入内容");
          return false;
        }
      });
    },

    songka() {
      this.$refs["formk"].validate(valid => {
        if (valid) {
          giveCardToUser(this.formk).then(res => {
            res.then(data => {
              if (data) {
                this.$message({
                  message: "操作成功",
                  type: "success"
                });
                this.dialogVisibleActive = false;
                this.formk.card_id = "";
                this.formk.mobile = "";
              }
            });
          });
        } else {
          alert("请检查输入内容");
          return false;
        }
      });
    },
    songDepositCard() {
      this.$refs["formdk"].validate(valid => {
        if (valid) {
          giveDepositCardToUser(this.formdk).then(res => {
            res.then(data => {
              if (data) {
                this.$message({
                  message: "操作成功",
                  type: "success"
                });
                this.dialogVisibleActive = false;
                this.formdk.card_id = "";
                this.formdk.mobile = "";
              }
            });
          });
        } else {
          alert("请检查输入内容");
          return false;
        }
      });
    },
    rechargeBalance() {
      this.rechargeBalanceButton = true;
      this.$refs["balanceForm"].validate(valid => {
        if (valid) {
          rechargeBalanceToUser(this.balanceForm).then(res => {
            // console.log(res)
            res.then(
              data => {
                if (data) {
                  // console.log(data)
                  this.$message({
                    message: JSON.stringify(data.data),
                    type: "success"
                  });
                  this.reload();
                  this.dialogVisibleActive = false;
                  this.balanceForm.money = "";
                  this.balanceForm.remark = "";
                  this.balanceForm.mobile = "";
                }
                // eslint-disable-next-line handle-callback-err
              },
              err => {
                this.rechargeBalanceButton = false;
              }
            );
          });
        } else {
          this.rechargeBalanceButton = false;
          alert("请检查输入内容");
          return false;
        }
      });
      // this.$message({
      //   message: '测试',
      //   type: 'success',
      // })
    },
    async returnBalance(row) {
      const [{ data: res }] = await Promise.all([
        refundBalanceToUser({ id: row.id, type: "query_refund" })
      ]);
      this.nickname = row.nickname;
      this.realName = row.truename;

      this.avatar = row.avatar;
      this.returnBalanceForm = res;
      this.returnBalanceFormId = row.id;
      this.BalanceShow = true;
    },
    balanceRefund() {
      refundBalanceToUser({
        id: this.returnBalanceFormId,
        type: "refund_balance"
      }).then(res => {
        res.then(data => {
          this.$message({
            message: "操作成功",
            type: "success"
          });
          // eslint-disable-next-line handle-callback-err
        });
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.label-name {
  text-align: right;
  // float: left;
  display: inline-block;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  width: 100px;
  padding: 0 12px 0 0;
  // -webkit-box-sizing: border-box;
  // box-sizing: border-box;
}
.textarea-class {
  display: inline-block;
  width: 300px;
}
.header-class {
  display: flex;
  justify-content: space-between;
  .wid-class {
      width: 400px;
      text-align: right;

      span {
          padding-right: 10px;
      }

      .font-col {
          color: rgb(216, 24, 24);
      }
  }
}
</style>
